<template>
    <div>
        <div class="row">
            <div class="col-md-12">
                <h5 v-if="!multiple" class="text-muted">{{$t('address.address')}}</h5>
                <h5 v-if="multiple" class="text-muted">{{$t('address.addresses')}}</h5>
            </div>
        </div>
        <div v-for="(item, index) in values">
            <div class="row" v-if="multiple">
                <div class="col-md-12">
                    <p class="text-primary border-bottom" v-if="multiple">
                        <b>{{$t('address.address')}} {{ index + 1 }}</b>
                    </p>
                    <label for="type">{{$t('address.type')}}</label>
                    <input
                        type="text"
                        class="form-control"
                        id="type"
                        v-model="item.type"
                        @input="updateValue"
                    />
                    <small class="text-muted">{{$t('address.typetext')}}</small>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <label for="address">{{$t('address.address')}}</label>
                    <textarea
                        class="form-control"
                        id="address"
                        v-model="item.address"
                        @input="updateValue"
                    ></textarea>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <label for="disctrict">{{$t('address.district')}}</label>
                    <input
                        type="text"
                        class="form-control"
                        id="disctrict"
                        v-model="item.district"
                        @input="updateValue"
                    />
                </div>
                <div class="col-md-6">
                    <label for="city">{{$t('address.city')}}</label>
                    <input
                        type="text"
                        class="form-control"
                        id="city"
                        v-model="item.city"
                        @input="updateValue"
                    />
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <label for="state">{{$t('address.state')}}</label>
                    <input
                        type="text"
                        class="form-control"
                        id="state"
                        v-model="item.state"
                        @input="updateValue"
                    />
                </div>
                <!-- <div class="col-md-6">
                <!-- <label for="country">Country</label>-->
                <input
                    type="hidden"
                    class="form-control"
                    id="country"
                    v-model="item.country"
                    @input="updateValue"
                />
                <!-- </div> -->
            </div>
        </div>
        <div class="row" v-if="multiple">
            <div class="col-md-12">
                <a
                    href="#"
                    v-if="values.length > 1"
                    class="btn btn-sm mr-3"
                    @click="deleteValue()"
                >Delete last Address</a>
                <a href="#" class="btn btn-sm" @click="addValue()">{{$t('address.addaddress')}}</a>
            </div>
        </div>
    </div>
</template>
<script>
export default {
  inheritAttrs: false,
  name: "fg-address",
  props: {
    value: "",
    multiple: false
  },
  data() {
    return {
      values: [
        {
          type: "",
          address: "",
          district: "",
          city: "",
          state: "",
          country: "Brazil"
        }
      ]
    };
  },
  watch: {
    value: function(newData) {
      this.values = newData;
    }
  },
  methods: {
    updateValue() {
      this.$emit("input", this.values);
    },
    deleteValue() {
      let i = this.values.length - 1;
      if (i > 0) {
        this.values.splice(i, 1);
        this.$emit("input", this.values);
      }
    },
    addValue() {
      this.values.push({});
      this.$emit("input", this.values);
    }
  }
};
</script>
<style>
</style>
